import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

export default function ExpiredLink() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const referral_API = async () => {
    setisLoading(true);
    try {
      let response = await API?.post(
        "/UpdatePHLinkList",
        {
          loginid: userId,
          type: "ExpiredLinkList",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      const data = response?.data?.data?.[0] || [];
      const cleanedData = data.map((item) => ({
        sr: item.row,
        id: item?.id,
        fromid: item?.fromid,
        lvl: item?.lvl,
        Link_Amount: item?.Link_Amount,
        ed: item?.ed,
        dd: item?.dd,
        name: item?.fromname,
        Mobile: item?.frommobile,
        email: item?.fromemail,
      }));

      setleftreferralApi(cleanedData);
    } catch (e) {
      console.log("Error in referral_API", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  const my_team = {
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "From Id", accessor: "fromid" },
      { Header: "Name", accessor: "name" },
      { Header: "Mobile", accessor: "Mobile" },
      { Header: "Email", accessor: "email" },
      { Header: "Level", accessor: "lvl" },
      { Header: "Amount", accessor: "Link_Amount" },
      { Header: "Date", accessor: "dd" },
      { Header: "Expire Date", accessor: "ed" },
    ],
  };

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title">Expired PH Help Link List</h4>
                </div>
                <div className="panel-body">
                  <div className="row">
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />
                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
